import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "../components/ui/dialog";
import { Plus, Edit3, Trash2, Star } from "lucide-react";
import { toast } from "sonner";

const CAT = ["buffet", "som", "projecao", "credenciamento", "cenografia", "instrutores", "midia", "comunicacao", "brindes", "camisas", "outros"];
const empty = { name: "", category: "buffet", contact_name: "", phone: "", email: "", cnpj: "", rating: 0, notes: "" };

export default function Vendors() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/vendors").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name) return toast.error("Nome obrigatório");
    if (editing) await api.put(`/vendors/${editing}`, form);
    else await api.post("/vendors", form);
    toast.success("Salvo");
    setOpen(false); setForm(empty); setEditing(null); load();
  };
  const edit = (v) => { setForm({ ...v }); setEditing(v.vendor_id); setOpen(true); };
  const remove = async (id) => { await api.delete(`/vendors/${id}`); load(); };
  return (
    <div className="p-10 max-w-[1200px]">
      <div className="flex items-end justify-between mb-8">
        <div><p className="overline">Homologados</p><h1 className="font-heading text-4xl mt-2">Fornecedores</h1></div>
        <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) { setForm(empty); setEditing(null); } }}>
          <DialogTrigger asChild><Button className="bg-[#C07C88]" data-testid="new-vendor-btn"><Plus size={16} className="mr-1" /> Novo fornecedor</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editing ? "Editar" : "Novo"} fornecedor</DialogTitle><DialogDescription>Mantenha um cadastro homologado de fornecedores para vincular ao checklist de cada evento.</DialogDescription></DialogHeader>
            <div className="grid md:grid-cols-2 gap-3">
              <div className="md:col-span-2"><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="vendor-name" /></div>
              <div>
                <Label>Categoria</Label>
                <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full h-10 px-3 border border-input rounded-md text-sm bg-white">
                  {CAT.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div><Label>Contato</Label><Input value={form.contact_name} onChange={(e) => setForm({ ...form, contact_name: e.target.value })} /></div>
              <div><Label>Telefone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              <div><Label>E-mail</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
              <div><Label>CNPJ</Label><Input value={form.cnpj} onChange={(e) => setForm({ ...form, cnpj: e.target.value })} /></div>
              <div><Label>Nota (0-5)</Label><Input type="number" min="0" max="5" value={form.rating} onChange={(e) => setForm({ ...form, rating: +e.target.value })} /></div>
              <div className="md:col-span-2"><Label>Observações</Label><Textarea rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
            </div>
            <DialogFooter><Button className="bg-[#C07C88]" onClick={save} data-testid="save-vendor-btn">Salvar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <Card className="border-border shadow-none">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground"><th className="p-4">Nome</th><th className="p-4">Categoria</th><th className="p-4">Contato</th><th className="p-4">Nota</th><th></th></tr></thead>
          <tbody>
            {items.map((v) => (
              <tr key={v.vendor_id} className="border-t border-border" data-testid={`vendor-${v.vendor_id}`}>
                <td className="p-4 font-medium">{v.name}</td>
                <td className="p-4 text-xs uppercase tracking-wider">{v.category}</td>
                <td className="p-4 text-xs">{v.contact_name} · {v.phone} · {v.email}</td>
                <td className="p-4">{Array.from({length:v.rating}).map((_,i)=> <Star key={`${v.vendor_id}-star-${i}`} size={12} className="inline text-[#D4AF37] fill-[#D4AF37]" />)}</td>
                <td className="p-4 text-right space-x-1">
                  <button onClick={() => edit(v)} className="p-1.5 hover:text-[#C07C88]"><Edit3 size={14} /></button>
                  <button onClick={() => remove(v.vendor_id)} className="p-1.5 hover:text-red-500"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-sm text-muted-foreground">Nenhum fornecedor cadastrado</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
